import { MouseEvent } from 'react';

import { TLocalesKeys } from '../../../../types';
import { isValidDate } from '../../../../util/guards';
import { renderModel } from '../../../util/renderModel';

export enum STATUS {
  OPEN = 100,
  PENDING = 110,
  CLOSED = 120,
  SOLVED = 140,
  INVESTIGATING = 150,
}

type TStatusMap = {
  readonly [k in STATUS]: TLocalesKeys;
};

export const getStatusKey = (status: STATUS): TLocalesKeys => {
  const map: TStatusMap = {
    [STATUS.OPEN]: 'ticket_status_open',
    [STATUS.PENDING]: 'ticket_status_pending',
    [STATUS.CLOSED]: 'ticket_status_closed',
    [STATUS.SOLVED]: 'ticket_status_solved',
    [STATUS.INVESTIGATING]: 'ticket_status_investigating',
  };

  return map[status] || map[STATUS.OPEN];
};

export const toLocaleDateString = (date: number): string => {
  const locale = renderModel.getLocale();
  const t = new Date(date).toLocaleDateString(locale);

  return isValidDate(t) ? ` (${t}) ` : '';
};

export const stopPropagation = (event: MouseEvent<HTMLElement>) => {
  event.stopPropagation();
};
